import { Box, IconButton, Typography } from '@mui/material';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MainArticleImg from '../../assets/MainArticle image.webp';
import React from 'react';

// import { useNavigate } from "react-router-dom";

export const MainBlog = (props) => {
	// const navigate = useNavigate;
	// const handleClick = (id) => {
	//   navigate(`/blogs/${id}`); // Replace '/other-component' with the desired path
	// };
	let id = props.id;
	let title = props.title;
	let image = props.image;
	let description = props.description;
	return (
		<>
			{/* <Card sx={{ display: "flex", flexDirection: "column", mb: 4 }}>
        <CardMedia
          component="img"
          sx={{ width: "90%" }}
          image={image || MainArticleImg}
          alt={title || "pixel Drop"}
          // sx={{ objectFit: 'cover' }}
        />
        <CardContent
          sx={{
            border: "solid",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h4" component="div" gutterBottom>
              {title ||
                "Title: Lorem ipsum dolor sit amet consectetur. Amet fringilla cursus lectus"}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Typography variant="body1" mt={2}>
              {description ||
                "Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim e"}
            </Typography>
            <IconButton>
              <ArrowForwardIcon />
            </IconButton>
          </Box>
        </CardContent>
      </Card> */}
			{/* <Box onClick={() => handleClick(id)}> */}
			<Box
				sx={{
					maxWidth: '100%',
					height: '100%', // Ensure full height
					display: 'flex',
					flexDirection: 'column',
					// justifyContent: "space-between", // Space between content
					// position: "relative",
				}}
			>
				<Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
					<Box sx={{ position: 'relative', width: '95%', left: 0 }}>
						<img
							src={image || MainArticleImg}
							alt={title || ''}
							style={{
								width: '100%',
								height: 'auto',
								// objectFit: "cover",
								maxWidth: '100%',
							}}
						/>
					</Box>
				</Box>
				<Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
					<Box
						sx={{
							position: 'relative',
							top: -40,
							// bottom: 16,
							// left: 16,
							// right: "1rem",
							backgroundColor: 'white',
							border: '1px solid #bfc0c1',
							boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.5)',
							borderBottomRightRadius: 15,
							borderBottomLeftRadius: 15,
							p: 3,
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
							// alignItems: "start",
							width: { sm: '100%', md: '90%' },
						}}
					>
						<Typography
							variant="h5"
							component="div"
							gutterBottom
							sx={{ textAlign: 'left' }}
						>
							{title ||
								'Title: Lorem ipsum dolor sit amet consectetur. Amet fringilla cursus lectus'}
						</Typography>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ mb: 2, textAlign: 'left' }}
						>
							{description ||
								'Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim e'}
						</Typography>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'row',
								textAlign: 'right',
								width: '100%',
								justifyContent: 'flex-end',
							}}
						>
							<IconButton>
								<ArrowForwardIcon />
							</IconButton>
						</Box>
					</Box>
				</Box>
			</Box>
		</>
	);
};
